import types from '../actions/types';
import produce from "immer/dist/immer";

import _each from 'lodash/each';
//
// const initialState = {
//   items: [
//     {
//       id: 15,
//       name: 'Tシャツ',
//
//     }
//   ],
//   loading: false,
//   currentItem: {
//     id: 15,
//     name: 'Tシャツ',
//   },
//   colors: [
//     {
//       "id": 52,
//       "name": "ブラウン",
//       "color": "#795f49",
//       "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/05ee41304477198b0adc5eacc8012193.png",
//       "images": [
//         {
//           "id": 1,
//           "surface": {
//             "id": 6,
//             "name": "背面",
//             "price": 1750
//           },
//           "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/05ee41304477198b0adc5eacc8012193.png",
//           "x": 0,
//           "y": 0,
//           "width": 0,
//           "height": 0
//         },
//         {
//           "id": 2,
//           "surface": {
//             "id": 5,
//             "name": "前面",
//             "price": 1750
//           },
//           "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/4bcf3ad1045ed36df33737bb7b9247ec.png",
//           "x": 0,
//           "y": 0,
//           "width": 0,
//           "height": 0
//         },
//         {
//           "id": 3,
//           "surface": {
//             "id": 8,
//             "name": "左袖",
//             "price": 750
//           },
//           "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/bf7f237a5c332e3795f9f5914d62742f.png",
//           "x": 0,
//           "y": 0,
//           "width": 0,
//           "height": 0
//         },
//         {
//           "id": 4,
//           "surface": {
//             "id": 7,
//             "name": "右袖",
//             "price": 750
//           },
//           "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/da3f3a5532f586c117dde293f73da24f.png",
//           "x": 0,
//           "y": 0,
//           "width": 0,
//           "height": 0
//         }
//       ]
//     }
//   ],
//   currentColor:  {
//     "id": 52,
//     "name": "ブラウン",
//     "color": "#795f49",
//     "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/05ee41304477198b0adc5eacc8012193.png",
//     "images": [
//       {
//         "id": 1,
//         "surface": {
//           "id": 6,
//           "name": "背面",
//           "price": 1750
//         },
//         "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/05ee41304477198b0adc5eacc8012193.png",
//         "x": 0,
//         "y": 0,
//         "width": 0,
//         "height": 0
//       },
//       {
//         "id": 2,
//         "surface": {
//           "id": 5,
//           "name": "前面",
//           "price": 1750
//         },
//         "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/4bcf3ad1045ed36df33737bb7b9247ec.png",
//         "x": 0,
//         "y": 0,
//         "width": 0,
//         "height": 0
//       },
//       {
//         "id": 3,
//         "surface": {
//           "id": 8,
//           "name": "左袖",
//           "price": 750
//         },
//         "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/bf7f237a5c332e3795f9f5914d62742f.png",
//         "x": 0,
//         "y": 0,
//         "width": 0,
//         "height": 0
//       },
//       {
//         "id": 4,
//         "surface": {
//           "id": 7,
//           "name": "右袖",
//           "price": 750
//         },
//         "image": "https://t-project-demo.s3.ap-northeast-1.amazonaws.com/da3f3a5532f586c117dde293f73da24f.png",
//         "x": 0,
//         "y": 0,
//         "width": 0,
//         "height": 0
//       }
//     ]
//   },
//   "sizes": [
//     {
//       "id": 43,
//       "symbol": "XS",
//       "name": "XSサイズ"
//     },
//     {
//       "id": 44,
//       "symbol": "S",
//       "name": "Sサイズ"
//     },
//     {
//       "id": 45,
//       "symbol": "M",
//       "name": "Mサイズ"
//     },
//     {
//       "id": 46,
//       "symbol": "L",
//       "name": "Lサイズ"
//     },
//     {
//       "id": 47,
//       "symbol": "XL",
//       "name": "XLサイズ"
//     }
//   ],
//   totalAmount: 1,
//   amount: {
//     43: 0,
//     44: 0,
//     45: 0,
//     46: 0,
//     47: 1
//   },
//   price: {
//     body: 2000,
//     surfaces: [
//       {
//         "id": 5,
//           "name": "前面",
//           "price": 1750
//       },
//     ],
//     discount: 0,
//     total: 5000
//   }
// };

const initialState = window.tProjectGlobals.initialStates.products;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.CHANGE_AMOUNT:
      return produce(state, draftState => {
        draftState.amount[action.payload.id] = parseInt(action.payload.value, 10);

        let total = 0;
        _each(draftState.amount, (v) => {
          total += (v || 0);
        });

        draftState.totalAmount = total;
      });
    case types.SELECT_COLOR:
      return produce(state, draftState => {
        draftState.currentColor = action.payload.color;
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/productsReducer.js